export const setWidthParamInImageUrl = (width: number, url?: string) => {
  if (!url) return url;
  const resolvedWidth = width;
  // If width param exists, replace it; else, add it (preserving other params)
  if (url.includes("width=")) {
    return url.replace(/width=\d+/g, `width=${resolvedWidth}`);
  }
  // Add width param, preserving existing params
  return url.includes("?")
    ? `${url}&width=${resolvedWidth}`
    : `${url}?width=${resolvedWidth}`;
};
